import { useTranslation } from "react-i18next";
import spmlogo from "../../resources/img/spmlogo.png";
import Spinner from "../spinner/Spinner";

const Title = ({ errorMessage, loading }) => {
  const { t } = useTranslation();
  const spinner = loading && <Spinner />;

  return (
    <div className="w3-display-container content-container content-container-full">
      <div className="title-view">
        {errorMessage}
        <div className="w3-center form-display-drugs medication-content">
          <div className="w3-panel w3-card-4 record-panel">
            {/*<div className="alert-banner w3-padding-small w3-margin-bottom">
              <p className="alert-banner-text">
                ⚠️ ATTENTION: This is a TEST SERVER. Do not use for EmPaSafe study.
              </p>
            </div>*/}
            <h1 className="w3-margin-bottom hero-title">{t("title_welcome")}</h1>
            {/*<p className="hero-subtitle">{t("title_subline")}</p>
             <div className="hero-divider" aria-hidden="true" />*/}
            <img src={spmlogo} alt="SPM logo" className="spm-logo w3-margin-top w3-margin-bottom" />
          </div>
          <div className="w3-panel w3-card-4 w3-center disclaimer-background hero-disclaimer w3-padding">
            <div className="disclaimer-text">
              ⚠️ {t("title_disclaimer")} {t("title_disclaimer_2")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Title;
